import { colors } from 'ui/theme/colors';
import { SvgIcon, SvgIconProps } from '../SvgIcon';
import { getColor } from '../utils';

export const Design = ({
  height = 24,
  width = 24,
  color = colors.grey90,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon width={width} height={height} viewBox="0 0 24 24" {...props}>
    <path
      d="M19.3125 4.5H4.6875C4.06618 4.5 3.5625 5.00368 3.5625 5.625V18.375C3.5625 18.9963 4.06618 19.5 4.6875 19.5H19.3125C19.9338 19.5 20.4375 18.9963 20.4375 18.375V5.625C20.4375 5.00368 19.9338 4.5 19.3125 4.5Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.5625 7.875H20.4375"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.75 10.3125H6.75C6.43934 10.3125 6.1875 10.5643 6.1875 10.875V13.5C6.1875 13.8107 6.43934 14.0625 6.75 14.0625H9.75C10.0607 14.0625 10.3125 13.8107 10.3125 13.5V10.875C10.3125 10.5643 10.0607 10.3125 9.75 10.3125Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.1875 16.6875H10.3125"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.25 10.3125H13.875C13.5643 10.3125 13.3125 10.5643 13.3125 10.875V16.125C13.3125 16.4357 13.5643 16.6875 13.875 16.6875H17.25C17.5607 16.6875 17.8125 16.4357 17.8125 16.125V10.875C17.8125 10.5643 17.5607 10.3125 17.25 10.3125Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3125 13.5H17.8125"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
